// TODO(engineer): FORECAST_RUNS is a fully hardcoded, tenant-specific (nile) table of
// fct → run_id, imported live into ProductStockingContainer. Follow-up: replace with a live lookup against the solutions/forecast
// list endpoint (same pattern as useFctForecasts in the forecasts feature), scoped by
// the current tenant, and delete this file.
// Forecast runs available for nile, newest first.
// Each entry maps a forecast creation date (fct) to its MDS run_id.
export const FORECAST_RUNS: Array<{ fct: string; forecast_run_id: string }> = [
  { fct: '2025-08-31', forecast_run_id: '25e0350d-c3c7-41eb-aa28-3ed64d80c342' },
  { fct: '2025-08-24', forecast_run_id: '02c28972-c05e-4a9f-ba06-4e1f36ff5c7e' },
  { fct: '2025-08-17', forecast_run_id: '917e47ba-db9c-40f2-bdab-16f284942717' },
  { fct: '2025-08-10', forecast_run_id: '7faef0fe-a20b-48cc-a8db-a4b3235744f6' },
  { fct: '2025-08-03', forecast_run_id: '61133b5d-a328-41b3-a04e-e97b4fa51ecc' },
  { fct: '2025-07-27', forecast_run_id: '1dc65fde-80a9-4cca-a557-0e75d49c9e9b' },
  { fct: '2025-07-20', forecast_run_id: 'bdfff674-1c62-4917-bce6-574cc70e2138' },
  { fct: '2025-07-13', forecast_run_id: 'f66a14a0-9e9e-4531-88fa-e799583ec05e' },
  { fct: '2025-07-06', forecast_run_id: '10b742b3-7799-4d63-b506-5b7ac2dd45b8' },
  { fct: '2025-06-29', forecast_run_id: '2bc62802-355b-49b0-b4d1-9d24507dd4be' },
  { fct: '2025-06-22', forecast_run_id: 'd4eeae5b-aab2-430a-ab27-39ba001fda32' },
  { fct: '2025-06-15', forecast_run_id: '641ed56b-d2a9-443d-885d-743fc0cc58e4' },
  { fct: '2025-06-08', forecast_run_id: 'fc397948-edcb-435c-8ee3-40c34855889a' },
  { fct: '2025-06-01', forecast_run_id: '38e81d43-02ba-4d56-9b4c-77e980d11fe6' },
  { fct: '2025-05-25', forecast_run_id: 'e16d418c-9bc3-428c-ad4e-4c104b9ccf31' },
  { fct: '2025-05-18', forecast_run_id: '1ecbad53-638c-420c-850d-9c22828bdab3' },
  { fct: '2025-05-11', forecast_run_id: 'dfb95df8-f237-4d75-87ca-fd41b9b5b5dd' },
  { fct: '2025-05-04', forecast_run_id: '5fe1db6e-b7f1-4060-b06a-1760dde8d191' },
  { fct: '2025-04-27', forecast_run_id: '92f564c3-b85e-409c-8b16-1c3cabf62624' },
  { fct: '2025-04-20', forecast_run_id: 'c90f4eb2-5fcf-4800-9c74-6964064555a7' },
  { fct: '2025-04-13', forecast_run_id: 'b96fb9b8-e436-4b5f-8452-1ed93583babb' },
  { fct: '2025-04-06', forecast_run_id: 'cfbb927b-d225-4e30-a25f-3262d56d84ba' },
  { fct: '2025-03-30', forecast_run_id: '4640581d-fb08-49e6-9ca4-c895a53f52a1' },
  { fct: '2025-03-23', forecast_run_id: '057eb2e6-3c54-4da6-a492-2330b0b2e967' },
  { fct: '2025-03-16', forecast_run_id: '5f0ac04e-f1d5-4620-999a-4a009fe6026a' },
  { fct: '2025-03-09', forecast_run_id: '3eb4dea0-7917-47ae-8d07-8ef505142f6d' },
  { fct: '2025-03-02', forecast_run_id: 'cd199335-7698-4152-a95a-bb3203730fc6' },
  { fct: '2025-02-23', forecast_run_id: '6da4cac6-e84e-440b-8648-4b2ba7879873' },
  { fct: '2025-02-16', forecast_run_id: '6b4e43dc-7e92-466b-860c-354c0ada8609' },
  { fct: '2025-02-09', forecast_run_id: '2b377d13-578d-47d1-a9b1-13257eb27d94' },
  { fct: '2025-02-02', forecast_run_id: '30f8212a-1336-4195-b267-7a8341c28ad4' },
  { fct: '2025-01-26', forecast_run_id: 'db5a3bcd-b142-4f0f-a61c-6f6b243b4233' },
  { fct: '2025-01-19', forecast_run_id: 'f54d9d95-9fad-403e-ad17-785da6e334a1' },
  { fct: '2025-01-12', forecast_run_id: '4658bdf0-23d2-4073-8e7b-4821b69e2fc4' },
  { fct: '2025-01-05', forecast_run_id: '244b9d4a-9fe7-49ce-8897-ad49bb02b1f9' },
  { fct: '2024-12-29', forecast_run_id: 'ab4a98d1-0ded-4d82-be9a-df8340a4dcd1' },
  { fct: '2024-12-22', forecast_run_id: '3cdf0a94-bbde-48a8-8123-e4ef3a495567' },
  { fct: '2024-12-15', forecast_run_id: '9a6bc0af-4df1-450f-83b7-a4b61b78cba1' },
  { fct: '2024-12-08', forecast_run_id: '68b6d205-344c-4f06-87e9-9ceaa73933b5' },
  { fct: '2024-12-01', forecast_run_id: '1fcfff1a-f3fe-461f-a87a-21b1a7dce4ce' },
  { fct: '2024-11-24', forecast_run_id: '08af646a-2887-4ac3-83b0-728316b3ab87' },
  { fct: '2024-11-17', forecast_run_id: '33a688df-2842-41c2-b2f5-2ecba60c56b0' },
  { fct: '2024-11-10', forecast_run_id: '5441064a-bea3-43eb-9747-58511261675e' },
  { fct: '2024-11-03', forecast_run_id: '05675ad4-3229-4886-b374-9058d793ccab' },
  { fct: '2024-10-27', forecast_run_id: 'e031f21b-fe44-4725-b6d8-5e5a3870fea1' },
  { fct: '2024-10-20', forecast_run_id: 'e6724e8e-114a-4671-955a-80f53b9cac30' },
  { fct: '2024-10-13', forecast_run_id: 'a4d2e08d-26d0-431a-8859-f9573a67ebd6' },
  { fct: '2024-10-06', forecast_run_id: '75e97335-9ee6-4cec-9a9a-4e3c1561d7da' },
  { fct: '2024-09-29', forecast_run_id: 'd37748da-74ec-4889-8844-8d5ce63ed95d' },
  { fct: '2024-09-22', forecast_run_id: 'be8a4e98-4b69-46d4-87f3-83cc50f117d8' },
  { fct: '2024-09-15', forecast_run_id: '4d9a4bfc-58fc-4ea8-b19a-c199536ca8f0' },
  { fct: '2024-09-08', forecast_run_id: '239af75b-68cc-4be6-a01e-05c6925aad8a' },
  { fct: '2024-09-01', forecast_run_id: '9825094e-dc5e-476d-974e-7de7f6fd3617' },
  { fct: '2024-08-25', forecast_run_id: 'e5d7a919-b4c4-4cc2-9108-2ac52ac2f31a' },
  { fct: '2024-08-18', forecast_run_id: '3ac788ed-452a-4e0b-a24f-38fd392cf100' },
  { fct: '2024-08-11', forecast_run_id: 'cf2e3291-a324-4660-88ac-c9e6e7946016' },
  { fct: '2024-08-04', forecast_run_id: '2c844e8b-5791-417e-bc5b-65e3792ed4b1' },
  { fct: '2024-07-28', forecast_run_id: 'b7bd2df9-43d6-45af-8a8e-858fc52ea6f8' },
];
